const UNDEFINED_VALUE = '';
export function getFilterOptionTitle(title) {
    return typeof title === 'string' ? title : '';
}
export function encodeOptionId(id) {
    return id === undefined ? UNDEFINED_VALUE : String(id);
}
export function findOptionByEncodedValue(options, encoded) {
    return options.find(option => encodeOptionId(option.id) === encoded);
}
export function encodeOptionIds(ids) {
    return ids.map(encodeOptionId);
}
export function findOptionsByEncodedValues(options, encoded) {
    return encoded
        .map(item => findOptionByEncodedValue(options, item))
        .filter((option) => option !== undefined);
}
